if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();

      const title = this.dataset.productTitle || '';
      const url = this.dataset.productUrl || '';
      const img = this.dataset.productImage || '';
      const imgAlt = this.dataset.productImageAlt || title || '';
      const price = this.dataset.productPrice || '';

      this.setProductTitle(title, url);
      this.setProductImage(img, imgAlt, url, title);
      this.setProductPrice(price);

      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) notification.dismiss();
      });
    }

    formatTitle(rawTitle) {
      let t = rawTitle || '';

      // Remove certain phrases
      t = t
        .replace(/Short Sleeve/gi, '')
        .replace(/Long Sleeve/gi, '');

      // Replace " - " with a line break
      t = t.replace(/\s-\s/g, '<br>');

      // Clean up spacing and duplicate breaks
      t = t
        .replace(/\s{2,}/g, ' ')
        .replace(/<br>\s*<br>/g, '<br>')
        .trim();

      return t;
    }

    setProductTitle(productTitle, productUrl) {
      const formattedTitle = this.formatTitle(productTitle);

      const titleLink = this.querySelector('.added-notification__title-link');
      const titleDiv = this.querySelector('.added-notification__message-title'); // in case older markup still exists

      if (titleLink) {
        titleLink.innerHTML = formattedTitle; // innerHTML so <br> renders
        if (productUrl) titleLink.setAttribute('href', productUrl);
        titleLink.setAttribute('aria-label', productTitle || '');
      }

      if (titleDiv) {
        titleDiv.innerHTML = formattedTitle;
      }
    }

    setProductImage(imageUrl, altText, productUrl, productTitle) {
      const img = this.querySelector('.added-notification__thumb');
      const link = this.querySelector('.added-notification__thumb-link');

      if (!img || !link) return;

      if (imageUrl) {
        img.src = imageUrl;
        img.alt = altText || productTitle || '';
        img.removeAttribute('hidden');
        link.removeAttribute('hidden');
      } else {
        link.setAttribute('hidden', 'hidden');
        img.setAttribute('hidden', 'hidden');
      }

      if (productUrl) {
        link.setAttribute('href', productUrl);
        link.setAttribute('aria-label', productTitle || 'View product');
      }
    }

    setProductPrice(priceText) {
      const priceEl = this.querySelector('.added-notification__price');
      if (!priceEl) return;

      if (priceText) {
        priceEl.textContent = priceText;
        priceEl.removeAttribute('hidden');
      } else {
        priceEl.setAttribute('hidden', 'hidden');
      }
    }

    display() {
  // reveal
  setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

  // dismiss after 6 seconds
  clearTimeout(this.delayedDismissTimeout);
  this.delayedDismissTimeout = setTimeout(() => this.dismiss(), 6000);

  // close button
  this.querySelector('.added-notification__close')
    ?.addEventListener('click', this.dismiss.bind(this));

  // cart drawer interception stays the same
  if (theme.settings.cartType === 'drawer') {
    const cartLinks = this.querySelectorAll('.added-notification__message-text a[href$="/cart"]');
    cartLinks.forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.querySelector('.js-cart-drawer')?.open(evt.currentTarget);
        this.dismiss();
      });
    });
  }
}

    dismiss(evt) {
      if (evt) evt.preventDefault();
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}